import React from 'react';
import AppleSignin from 'react-apple-signin-auth';
import './styles.css'; // Import the CSS file
import ApiService from '../../classes/ApiService';

  // User Information:

  // email: The user's email address. If the user chooses to hide their email, you'll receive a private relay email address.
  // name: The user's full name (if the user has chosen to share it).
  // Identity Token:

  // id_token: A JSON Web Token (JWT) that contains the user's identity information. This token is signed by Apple and can be decoded to extract user details.
    // {
  //   "iss": "https://appleid.apple.com",
  //   "aud": "com.example.web",
  //   "exp": 1582050096,
  //   "iat": 1582049496,
  //   "sub": "000109.6b2727499ac54f708cadbb624XXXXXXXXXX",
  //   "at_hash": "9t0o8H0a2uV6pO7F3NfGgQ",
  //   "email": "user@example.com",
  //   "email_verified": "true",
  //   "is_private_email": "true",
  //   "auth_time": 1582049496,
  //   "nonce_supported": true
  //   } 
  
  // Authorization Code:

  // code: A one-time authorization code that your server can exchange for a refresh token and access token.
  // State:

  // state: The state parameter you provided in the initial request, used to maintain state between the request and callback. 


const AppleSigninButton = ({ type, redirectURI, clientId, scope, state, nonce, usePopup, onSuccess, onError, text }) => {
  const handleAppleLogin = async (credentialResponse) => {
    try {
      const apiService = new ApiService();
      console.log(credentialResponse)
      const response = await apiService.post('/registration/guest/apple-login', { token: credentialResponse });
      // Forward the user to the core application
      localStorage.setItem('token', response.data.token);
      alert('Google Login successful');
    } catch (error) {
      console.error(error);
      onError(error);
    }
  };

  return (
    <AppleSignin
      authOptions={{
        clientId: clientId || 'com.example.web', // Your Service ID
        scope: scope || 'email name',
        redirectURI: redirectURI || 'https://example.com', // Your redirect URI
        state: state || 'state',
        nonce: nonce || 'nonce',
        usePopup: usePopup !== undefined ? usePopup : true, // Use popup for authentication
      }}
      uiType="light"
      className="apple-signin-btn"
      buttonExtraChildren={text ||  "Continue with Apple"}
      onSuccess={onSuccess || handleAppleLogin}
      onError={onError}
      //iconProp={{ style: { marginTop: '14px' } }} // default = undefined
      /** render function - called with all props - can be used to fully customize the UI by rendering your own component  */
      //render={(props) => <button {...props}>My Custom Button</button>}
    />
  );
};

export default AppleSigninButton;